export default __webpack_public_path__ + "static/hub-microscope-cb62b12ef251ff7cf6199eeb38e2c984.jpg";